import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ChatRepository} from "@dropDesk/domain/repositories/chat/chat.repository";
import {CancelTokenSource} from "axios";
import {ListPaginationChatMessagesEntity} from "@dropDesk/domain/entities/chat/list_pagination_chat_messages.entity";

@injectable()
export class ListChatMessagesV2UseCase {
    private _repository: ChatRepository;

    constructor(@inject(ChatRepository) repository: ChatRepository) {
        this._repository = repository;
    }

    public call(
        ticketId: string,
        page: number,
        limit: number,
        cancelTokenSource?: CancelTokenSource,
        direction?: 'up' | 'down'
    ): Promise<ListPaginationChatMessagesEntity> {
        return this._repository.loadMessagesV2(ticketId, page, limit, cancelTokenSource, direction);
    }
}
